// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import MsgDialog from './MsgDialog';
import DocTypeAddDialog from './DocTypeAddDialog';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SendIcon from '@mui/icons-material/Send';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ConfirmDialog from './ConfirmDialog';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from "dayjs"

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

export default function DocTypeTab(props) {
  const { sysID } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");


  const [gridData, setGridData] = useState([]);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  useEffect(() => {
    // console.log("useEffect DocTypeTab(did mounted)");
    refreshData();
  }, []);


  const refreshData = () => {

    setShowLoading(true);

    DmsService.getDocTypesPromise(gState.sessionID, sysID)
      .then((data) => {
        // console.log("DocType data: ", data);

        setShowLoading(false);

        setGridData(data);
      })
      .catch((e) => {
        setShowLoading(false);

        setGridData([]);

        console.log('Fail: ', e);

        // setErrMsg(e.errMsg || e.message);
        // setShowError(true);
        onCatchPromiseError(e);

      })
  }

  const [selectedRec, setSelectedRec] = useState(null);

  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();

    let selRecs = nodes.map(item => {
      return item.data
    });


    if (selRecs.length > 0) {
      setSelectedRec(selRecs[0])
    } else {
      setSelectedRec(null)
    }

  }


  const [openAddDialog, setOpenAddDialog] = useState(false);

  const [editMode, setEditMode] = useState(false);

  const handleAddClick = () => {
    setEditMode(false);
    setOpenAddDialog(true);
  }

  const handleEditClick = () => {
    setEditMode(true);
    setOpenAddDialog(true);
  }

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleConfirmDeleteClick = () => {
    setOpenConfirmDialog(false);

    setShowLoading(true);
    DmsService.delDocTypePromise(gState.sessionID, sysID, selectedRec.RefCode)
      .then(() => {

        setShowLoading(false);

        refreshData();
      })
      .catch((e) => {
        setShowLoading(false);

        // setErrMsg(e.errMsg || e.message);
        // setShowError(true);
        onCatchPromiseError(e);

      })
  }

  const handleAfterAdd = () => {
    setOpenAddDialog(false);
    refreshData();
  }


  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };


  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorRefCodeDesc = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.RefCodeDesc, nodeB.data.RefCodeDesc)
  }


  const columnDefs = [
    {
      field: 'RefCodeDesc', headerName: "RefCodeDesc", cellStyle: cellStyle, sort: "asc",
      flex: "1", comparator: comparatorRefCodeDesc
    },
  ];

  // <AgGridColumn field="RefCodeDesc" headerName="RefCodeDesc" cellStyle={cellStyle} flex="1" sort="asc" ></AgGridColumn>

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: "60vh" }} >
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />

      <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
        <Box sx={{ py: 1, px: 1 }} >

          <Button startIcon={<AddIcon />} onClick={handleAddClick} >
            Add
          </Button>

          <Button disabled={!selectedRec} startIcon={<EditIcon />} onClick={handleEditClick} >
            Edit
          </Button>

          <DocTypeAddDialog
            sysID={sysID}
            open={openAddDialog}
            onClose={() => setOpenAddDialog(false)}
            afterUpdate={handleAfterAdd}

            editMode={editMode}
            docType={selectedRec}
          />

          <Button disabled={!selectedRec} startIcon={<DeleteIcon />} onClick={() => setOpenConfirmDialog(true)} >
            Delete
          </Button>

          <ConfirmDialog
            open={openConfirmDialog}
            text={"Delete the selected Document Type?"}
            confirmBtnCaption='Delete'
            onCancelClick={() => {
              setOpenConfirmDialog(false);
            }}
            onConfirmClick={handleConfirmDeleteClick}
          />


        </Box>

        <AgGridReact

          rowData={gridData}

          defaultColDef={{
            width: 100,
            resizable: true,
            sortable: true,
            suppressMovable: true,
          }}
          columnDefs={columnDefs}
          headerHeight={40}

          suppressNoRowsOverlay

          rowSelection="single"
          onSelectionChanged={onSelectionChanged}
        >

        </AgGridReact>

      </div>

    </Box>


  );
}

DocTypeTab.propTypes = {
  sysID: PropTypes.string,
};
